import baseEn from '@gasbi/localizations/en.json';
import baseUa from '@gasbi/localizations/ua.json';

import overridesEn from './__mocks__/en.json';
import overridesUa from './__mocks__/ua.json';

export const LOCALE_NS = 'privateConsumers';

const ua = {
  ...baseUa,
  ...overridesUa,
};
const en = {
  ...baseEn,
  ...overridesEn,
};

export const locales = {
  ua: { [LOCALE_NS]: ua },
  en: { [LOCALE_NS]: en },
};

const lng = 'ua';
const supportedLangs = ['ua', 'en'];
const fallbackLng = 'en';
const defaultNS = LOCALE_NS;

export const i18nInstanceOptions = {
  locales,
  lng,
  supportedLangs,
  fallbackLng,
  defaultNS,
};
